export default {
    appName: process.env.REACT_APP_APP_NAME,
    apiURL: process.env.REACT_APP_API_URL,
    adminEmail: process.env.REACT_APP_ADMIN_EMAIL,
    adminPassword: process.env.REACT_APP_ADMIN_PASSWORD,
    tokenKey: process.env.REACT_APP_TOKEN_KEY,
}